import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Poppins:300,400,600&display=swap');
  
  body {
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
    background-color: #FFF;
  }
  
  .mdc-linear-progress {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    
    .mdc-linear-progress__bar-inner {
      background-color: #64C3E0;
    }
  }
  
  .ui.modal .header {
    background: #2E2E55 !important;
    color: #FFF;
    text-transform: uppercase;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-weight: 400 !important;
    border-bottom: 1px solid rgba(255, 255, 255, .1) !important;
  }
  
  .ui.modal .content {
    background: #2E2E55 !important;
    color: #FFF;
    font-family: 'Poppins', sans-serif;
    font-weight: 400 !important;
    
    .ui.table {
      background: transparent;
      border: 1px solid rgba(255, 255, 255, .1);
    }
  }
`;
